// extracted by mini-css-extract-plugin
module.exports = {"Modal":"style_Modal__18JAR","backdropped":"style_backdropped__Xfe5w"};